module Internal.Clipboard where

import Common

import Control.Promise (Promise, toAff)

writeText :: String -> Aff Unit
writeText = toAff <<< writeText_
foreign import writeText_ :: String -> Promise Unit
